module.exports = {
  root: true,

  env: {
    node: true,
  },

  extends: ["plugin:vue/essential", "eslint:recommended"],

  parserOptions: {
    parser: "babel-eslint",
  },

  globals: {
    config: "readable",
  },

  rules: {
    "no-debugger": process.env.NODE_ENV === "production" ? "error" : "warn",
    "no-unused-vars": process.env.NODE_ENV === "production" ? "error" : "warn",
    "vue/no-unused-components": process.env.NODE_ENV === "production" ? "error" : "warn",
  },
};
